import styled from "styled-components";

const List = styled.ul.attrs(props => ({
  className: "list pa0 mv1 gray"
}))``;

export default List;
